module.exports = __webpack_public_path__ + "static/media/ko-logo2.24d742f0.png";